@if (mpContextualMenu) {
  <div #contextualMenu class="menu">
    <ng-container [ngTemplateOutlet]="mpContextualMenu"
    [ngTemplateOutletContext]="{$implicit: mpContextualMenuData}"></ng-container>
  </div>
}
